import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Status } from '../../../../../models/statusEnums' //'src/app/models/statusEnums';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMainService } from 'src/app/app-main.service';
import { Log, LogAttachment, ObjectLog } from 'src/app/shared/model/models';
import { LogService } from 'src/app/shared/api/log.service';
import { LogService as CustomLogService } from '../../shared-logs/log-service.service';
import { uploadFiles, validateFiles } from '../../../../../../app/shared/upload-files';
import { DomSanitizer } from '@angular/platform-browser';
import {  Router } from '@angular/router';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';
import { Subscription } from 'rxjs';
import { AccountModuleId } from '../../../constants/modules.constant';

@Component({
    selector: 'app-lion-log-details-popup',
    templateUrl: './log-details.component.html',
    styleUrls: ['./log-details.component.scss']
})

export class LionLogDetailsPopupComponent implements OnInit, OnChanges {

    @Input() displayLogDetailPopup;
    @Input() logData;
    @Input() isViewMode = false;
    @Input() selectedModuleId: any = null;
    @Input() selectedAccountId: any = null;

    @Output() cancelLogPopupDetails = new EventEmitter<any>();

    isView = true;
    newComment = '';
    logTypes = [];
    selectedLog;
    logComment = '';
    isUpdateLog = false;
    isUpdateLogComment = false;
    logArea = true;
    selectedLogComments;
    multiLineTooltip = `<ul class="p-mt-0 p-pl-4 p-mb-0">
      <li>Files with extensions: gif, png, jpg, jpeg, pdf, txt, xls, xlsx, doc, docx, ppt, pptx are allowed</li>
      <li>Files size should not be more than 2MB</li>
    </ul>
  `;
    allowedExtensions = [
        ".pdf",
        ".csv",
        ".txt",
        ".xlsx",
        ".xls",
        ".docx",
        ".doc",
        ".png",
        ".jpg",
        ".jpeg",
        ".ppt",
        ".pptx",
        ".gif",
        ".zip",
    ]; // For the attachment files
    logAttachment: LogAttachment = {
        id: 0,
        createdSource: this.app.userIP,
        createdBy: this.app.user.userId,
        createdDate: new Date(),
        logId: 0,
        attachmentId: 0,
        attachment: {
            id: 0,
            createdSource: this.app.userIP,
            createdBy: this.app.user.userId,
            createdDate: new Date(),
            name: "",
            guidName: "",
            content: "",
            extension: "",
            sizeInBytes: 0,
            description: "",
            statusId: 0,
            isValid: true,
            validFromDate: null,
            validToDate: null,
        },
    };
    logTemp: ObjectLog = {
        id: 0,
        createdSource: this.app.userIP,
        createdBy: this.app.user.userId,
        objectId: 0,
        objectTypeId: 0,
        logId: 0,
        log: {
            id: 0,
            createdSource: this.app.userIP,
            createdBy: this.app.user.userId,
            commentMessage: "",
            typeId: 0,
            subTypeId: 0,
            organizationId: this.app.user.organizationId,
            description: "",
            statusId: Status.Active,
            isValid: true,
            validFromDate: null,
            validToDate: null,
            logComments: null,
            logAttachments: [],
        },
    };
    fileList:any[] = [];
    users = []
    selectedUserId: any;
	displayUserDetails = false;
    private userAccessSubscription: Subscription | null = null;
  /**Quill config */
  quillConfig={
    toolbar: false,
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      mentionDenotationChars: ["@"],
      showDenotationChar: false,
      spaceAfterInsert: false,
      source: (searchTerm, renderList, mentionChar) => {
        let values = this.users || [];
    
        if (searchTerm.length === 0) {
          renderList(values, searchTerm);
        } else {
          const matches = values.filter(user =>
            user.value?.toLowerCase().includes(searchTerm.toLowerCase())
          );
          renderList(matches, searchTerm);
        }
      },
    },
  }
  private documentClickListener!: () => void;
    constructor(
        private app: AppMainComponent,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private logService: LogService,
        private logServiceForOtherMethods: CustomLogService,
        private appMainService: AppMainService, private sanitizer: DomSanitizer,
        private router: Router,private accountService: AccountServiceN,
        
        ) {}

    ngOnInit(): void {
        this.getLogTypes();
        this.setUserList(this.selectedModuleId);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.logData?.currentValue) {
            this.logData = this.updatedLogData(this.logData);
        }
        if (changes?.isViewMode?.currentValue) {
            this.isViewMode = changes.isViewMode.currentValue;
        }
        if (changes?.selectedModuleId && changes?.selectedModuleId?.currentValue) {
            this.selectedModuleId = changes.selectedModuleId.currentValue;
        }
        if (changes?.selectedAccountId && changes?.selectedAccountId?.currentValue) {
            this.selectedAccountId = changes.selectedAccountId.currentValue;
            if(this.selectedModuleId === AccountModuleId){
                this.accountService.getUserAccessList(this.selectedAccountId);
            }
        }
    }
    ngAfterViewInit() {
        this.documentClickListener = this.handleDocumentClick.bind(this);
        document.addEventListener('click', this.documentClickListener);
      }
    

      setUserList(selectedModuleId: any) {
        if (selectedModuleId === AccountModuleId) {
            this.userAccessSubscription = this.accountService.userAccess$.subscribe((accessData) => {
              this.users = accessData.filter(user => user.userId !== this.app.userId).map((user) => ({
                id: user.userId,
                value: user.userName,
              })).sort((a, b) => a.value.localeCompare(b.value));
            });
          } else {
          this.users = this.app.usersList.filter(user => user.id !== this.app.userId).map((user) => ({
            id: user.id,
            value: user.name,
          })).sort((a, b) => a.value.localeCompare(b.value));
        }
      }
    
      private handleDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const mentionElement = target.closest('.mention');
    
        if (mentionElement) {
          event.stopPropagation(); // Stop event bubbling
          const userId = mentionElement.getAttribute('data-id');
          if (userId && userId !== this.selectedUserId) {
            this.openTaggedUserDetails(userId);
          }
        }
      }
      openTaggedUserDetails(userId: any) {
        this.selectedUserId = userId;
        this.displayUserDetails = true;
      }
      closeTaggedUserDetails(){
        this.selectedUserId = null;
        this.displayUserDetails = false;
      }

     updatedLogData(resp){
        this.logData = resp
        this.logData = { ...this.logData, newcommentMessage: this.sanitizer.bypassSecurityTrustHtml(this.logData.commentMessage) };
        this.logData.logComments = this.logData.logComments.map(commentObj => ({
            ...commentObj,
            comment: commentObj.comment
                ? { ...commentObj.comment,
                     newCommentMessage: this.sanitizer.bypassSecurityTrustHtml(commentObj.comment.commentMessage)
                    }
                : commentObj.comment
        }));
        return this.logData
     } 
    getLogTypes() {
        this.app.logTypesBSubject.subscribe(logTypes => {
            if (logTypes.length) {
                this.logTypes = logTypes;
                this.selectedLog = this.logTypes && this.logTypes.length ? this.logTypes[0] : null;
            }
        })
    }

    showHideUpdateLog(data) {
        if (data.commentMessage) {
            this.logComment = data.commentMessage;
        }
        if (data.comment) {
            this.logComment = data.comment.commentMessage;
        }

        this.isUpdateLog = true;
        this.logArea = false;
        this.selectedLog = this.logTypes.find(x => x.name == data.type?.name);
    }

    showHideUpdateLogComment(data, logData) {
        this.selectedLogComments = data;
        this.isUpdateLogComment = true;
        this.logArea = false;

        if (data.commentMessage) {
            this.logComment = data.commentMessage;
        }
        if (data.comment) {
            this.logComment = data.comment.commentMessage;
        }
        this.selectedLog = this.logTypes.find(x => x.name == logData.type?.name);
    }
    onSubmit(comment) {
        const mentionUsers = this.getMentions(comment);
        const selectedUserIds = mentionUsers.map(user => user.id);
        return (selectedUserIds);
    }
    getMentions(comment: string) {
      const mentionRegex = /<span class="mention"[^>]*data-id="(.*?)"[^>]*data-value="(.*?)"[^>]*>/g;
      let mentions: { id: number; name: string }[] = [];
      let uniqueMentionsMap = new Map<number, { id: number; name: string }>();
      let match;
      while ((match = mentionRegex.exec(comment)) !== null) {
        const id = parseInt(match[1], 10);
        const name = match[2];
        uniqueMentionsMap.set(id, { id, name });
      }
      mentions = Array.from(uniqueMentionsMap.values());
      return mentions;
    }
    updateLog() {
        const selectedUserIds = this.onSubmit(this.logComment);
        let logData: Log = this.logData;
        logData.updatedBy = this.app.user.userId;
        logData.updatedSource = this.app.userIP;
        logData.updatedDate = new Date().toISOString();
        logData.typeId = this.logData.typeId;
        logData.subTypeId = this.logData.subTypeId;
        logData.mentionedUserIds = selectedUserIds ;
        logData.commentMessage = this.logComment;
        for (let attachment of this.logData.logAttachments) {
            if (attachment.id !== 0 && attachment.attachment.statusId === 2) {
                attachment.updatedBy = this.app.user.userId;
                attachment.updatedDate = new Date();
                attachment.updatedSource = this.app.userIP;
                attachment.attachment.updatedBy = this.app.user.userId;
                attachment.attachment.updatedDate = new Date();
                attachment.attachment.updatedSource = this.app.userIP;
            }
        }
        this.logService.lionO36020APILogPut(logData)
            .subscribe(
                (res: any) => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Log updated successfully...' });
                    this.logServiceForOtherMethods.getLogById(this.logData.id).then(resp => {
                        this.logData = this.updatedLogData(resp) ;
                        this.isUpdateLog = false;
                        this.logArea = true;
                        this.logComment = '';
                        this.app.getAllObjects();
                    });
                },
                () => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data' })
                }
            );
    }

    updateLogComment() {
        const commentData = {
            "id": this.selectedLogComments.id,
            "createdSource": this.selectedLogComments ? this.selectedLogComments.createdSource : this.app.userIP,
            "createdBy": this.selectedLogComments ? this.selectedLogComments.createdBy : this.app.user.userId,
            "createdDate": this.selectedLogComments ? this.selectedLogComments.createdDate : new Date().toISOString(),
            "updatedBy": this.app.user.userId,
            "updatedDate": new Date(),
            "logId": this.selectedLogComments.logId,
            "commentId": this.selectedLogComments.commentId,
            "comment": {
                "id": this.selectedLogComments && this.selectedLogComments.comment ? this.selectedLogComments.comment.id : 0,
                "createdSource": this.selectedLogComments && this.selectedLogComments.comment ? this.selectedLogComments.comment.createdSource : this.app.userIP,
                "updatedSource": this.app.userIP,
                "createdBy": this.selectedLogComments && this.selectedLogComments.comment ? this.selectedLogComments.comment.createdBy : this.app.user.userId,
                "updatedBy": this.app.user.userId,
                "createdDate": this.selectedLogComments && this.selectedLogComments.comment ? this.selectedLogComments.comment.createdDate : new Date().toISOString(),
                "updatedDate": new Date(),
                "commentMessage": this.logComment,
                "statusId": this.selectedLogComments && this.selectedLogComments.comment ? this.selectedLogComments.comment.statusId : Status.Active,
                "isValid": this.selectedLogComments && this.selectedLogComments.comment ? this.selectedLogComments.comment.isValid : true,
                "validFromDate": null,
                "validToDate": null
            }
        }
        if (this.selectedLogComments) {

            this.logService.lionO36020APILogCommentPut(commentData)
                .subscribe(resp => {

                    this.selectedLogComments = null;
                    // this.selectdLogCommentForEdit = null
                    // this.logCommentForm.resetForm();
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment updated successfully...' });
                    this.logServiceForOtherMethods.getLogById(this.logData.id).then(resp => {
                        this.logData = this.updatedLogData(resp) ;
                        this.isUpdateLogComment = false;
                        this.logArea = true;
                        this.logComment = '';
                        this.app.getAllObjects();
                    });
                },
                    err => {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
                    })
        }
    }

    saveLogComment() {
        const selectedUserIds = this.onSubmit(this.newComment);
        this.appMainService.isShowSpinner('saveLogComment');
        const commentData = {
            "id": 0,
            "createdSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "createdDate": new Date(),
            "updatedBy": 0,
            "updatedDate": null,
            "logId": this.logData.id,
            "commentId": 0,
            "mentionedUserIds" :selectedUserIds ,
            "comment": {
                "id": 0,
                "createdSource": this.app.userIP,
                "updatedSource": "",
                "createdBy": this.app.user.userId,
                "updatedBy": 0,
                "createdDate": new Date(),
                "updatedDate": null,
                "commentMessage": this.newComment,
                "statusId": Status.Active,
                "isValid": true,
                "validFromDate": null,
                "validToDate": null
            }
        }

        this.logService.lionO36020APILogCommentPost(commentData)
            .subscribe(resp => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment added successfully...' });
                this.logServiceForOtherMethods.getLogById(this.logData.id).then(resp => {
                    this.logData = this.updatedLogData(resp) ;
                    this.isUpdateLogComment = false;
                    this.isUpdateLog = false;
                    this.logArea = true;
                    this.newComment = '';
                    this.app.getAllObjects();
                    this.appMainService.isHideSpinner('saveLogComment');
                });
            },
                err => {
                    this.appMainService.isHideSpinner('saveLogComment');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
                })

    }

    deleteComment(data) {
        this.confirmationService.confirm({
            message: 'Do you want to delete this Log Comment?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            key: 'logConfirmation',
            accept: () => {
                this.logService.lionO36020APILogCommentIdDelete(data.id).subscribe(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment deleted Successfully...' });
                    this.logServiceForOtherMethods.getLogById(this.logData.id).then(resp => {
                        this.logData = this.updatedLogData(resp) ;
                        this.app.getAllObjects();
                    });
                }, (error) => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' })
                })
            },
            reject: () => {
            }
        });
    }

    deleteLog() {
        this.confirmationService.confirm({
            message: 'Do you want to delete this Log?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            key: 'logConfirmation',
            accept: () => {
                this.logService.lionO36020APILogIdDelete(this.logData.id).subscribe(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    this.app.getAllObjects();
                    this.cancelLog();
                }, () => { this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting log...' }) })
            },
            reject: () => {
            }
        });
    }

    cancelLog() {
        this.isUpdateLog = false;
        this.isUpdateLogComment = false;
        this.displayLogDetailPopup = false;
        this.logArea = true;
        this.cancelLogPopupDetails.emit({ "cancelLogPopupDetails": this.displayLogDetailPopup });
        //this.logData = null;

        ////console.log("cancle call from child");

    }

    uploadAttachments(files: File[]) {
        this.appMainService.isShowSpinner('upload');
        if (typeof Worker !== undefined) {
          //  let errors = validateTotalFileSize(files, 25);
          for (let file of files) {
            let errors = validateFiles(file, 2, this.allowedExtensions);

            if (errors.length > 0) {
              for (let error of errors) {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: error.fileName + ": " + error.error
                });
              }

              this.appMainService.isHideSpinner('upload');
            } else {
              // this.newFileList.push(file);
              uploadFiles(file, ({ name, content, size, extension }) => {
                this.logAttachment.attachment = {
                    id: 0,
                    content,
                    name: name,
                    extension,
                    isValid: true,
                    sizeInBytes: size,
                    statusId: Status.Active,
                    createdBy: this.app.user.userId,
                    createdDate: new Date(),
                    createdSource: this.app.userIP,
                };
                this.logData.logAttachments.push(
                    this.app.copyObjectWithoutRefrence(
                        this.logAttachment
                    )
                );
                this.appMainService.isHideSpinner('upload');
              });
            }
          }
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
        }

      }

    removeAttachment(index: number){
        if(this.logData.logAttachments[index].id>0){
            this.logData.logAttachments[index].attachment.statusId = Status.Deleted
        }else{
            this.logData.logAttachments.splice(index, 1)
        }
    }
    ngOnDestroy() {
        document.removeEventListener('click', this.documentClickListener);
        this.userAccessSubscription?.unsubscribe();
      }

}
